import type { Immutable } from "immer";
import React from "react";

import type { LimitedOfferBlock as LimitedOfferBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    OfferPromo,
    OfferPromoImage,
    OfferPromoSubheader,
    OffersPromoContainer,
} from "../OffersPromo";

import styles from "./index.module.scss";

const richTextContents = (value: string | null | undefined): string =>
    (value ?? "")
        .replace(/^<div class="rich-text">/, "")
        .replace(/<\/div>$/, "");

export const LimitedOfferBlock = (
    props: Immutable<{ value: LimitedOfferBlockValue }>,
): React.JSX.Element => {
    const value = props.value;

    return (
        <OffersPromoContainer title={value.header} spacing={value.spacing}>
            <div className={styles.offerPromos}>
                {(value.offer_panes ?? []).map((pane, index) => (
                    <OfferPromo key={index}>
                        <h3 className={styles.offerPromoHeader}>
                            {pane.img_header}
                        </h3>
                        <OfferPromoImage
                            src={pane.img?.url ?? ""}
                            alt="Cocoon by Sealy Offer"
                        />
                        <OfferPromoSubheader>{pane.header}</OfferPromoSubheader>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: richTextContents(pane.copy),
                            }}
                        />
                        {(pane.buttons ?? []).map((button, buttonIndex) => (
                            <React.Fragment key={buttonIndex}>
                                {buttonIndex > 0 ? "\n" : null}
                                <a
                                    className={concatClassNames([
                                        styles.offerPromoButton,
                                        "button",
                                    ])}
                                    href={button.page?.url ?? ""}
                                >
                                    {button.link_title}
                                </a>
                            </React.Fragment>
                        ))}
                    </OfferPromo>
                ))}
            </div>
        </OffersPromoContainer>
    );
};
